var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagIcon = function SvgFlagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    fill: "none",
    viewBox: "0 0 19 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1818",
    d: "M0 16.01V.62h2.004l1.725.49c.482.129.965.232 1.452.322 4.612.882 9.74-.078 13.819 3.927-4.757-1.744-9.61.597-13.951 3.354a11.5 11.5 0 0 1-2.952 1.347q-.091.027-.093.026v5.924z"
  })));
};
export default SvgFlagIcon;